<template>
    <div class="container">
      <div class="flexCenter">
        <h2>{{ detail.activityName }}</h2>

        <el-row type="flex" justify="space-between" style="margin-top: 50px;color:#676C92;">
          <div > <i class="el-icon-view"></i> 点击量：{{ num }} </div>
          <div>发布时间：{{ detail.startTime.split(' ')[0]}}</div>
        </el-row>
          <el-image
            style="padding: 15px 0;width: 100%;"
            v-bind:src="detail.snapshotUrl"></el-image>
        </div>
      <div style="margin: 15px" class="dialog-footer">
        <el-button type="primary" @click="$router.push('/')">返 回</el-button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "",
    //接收父组件传递过来的参数
    props: ['message',"address"],
    //注册组件
    components: {},
    // 定义变量
    data() {
      return {
        detail: {
          snapshotUrl:""
        },
        num:0
      };
    },
    filters: {
      filTimeFormater (value) {
        return dayjs(value).format('YYYY-MM-DD HH:mm:ss')
      },
      // 默认第一个入参为time--即过滤器本身的值
      filTimeFormater2 (value, paraStr) {
        return dayjs(value).format(paraStr)
      },
    },
    created() {
        let url = this.$route.query
        let i = url.i
        console.log(i,"i")
        this.$api.upImage1(1,i).then(res =>{
          // console.log(res.data.data[i],"res")
          // if(res.data.data[i]){
            this.detail = res.data.data[0]
          // }else{
            // this.detail = ""
          // }
          // console.log(this.detail)
        })
         .catch(error => {  
          // handle error  
        });
        this.$api.getHits(i).then((res)=>{
          this.num = res.data.data
        })
    },
    //事件方法执行
    methods: {},
    //页面初始化方法
    mounted() {},
    //监听方法  click事件等，执行drawFeatures方法
    //监听值变化
    watch: {},
    //计算
    computed: {},
  };
  </script>
  
  <style scoped>
  @import "./../style/index.scss";
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin:20px 0 ;
  }
  .flexCenter {
    text-align: center;
    overflow-x: hidden;
    height: 100%;
    margin: 5vw auto;
    width: 50%;
    margin-top:20px ;
  }
  .topTitle{
    line-height: 24px;
    font-size: 20px;
    color: #303133;
    font-weight:900
  }
  /deep/ .el-dialog__title {
    font-weight: 900;
    font-size: 20px;
  }
  .UsDate {
    font-size: 13px;
    color: #858585;
    margin: 15px 0px;
  }
  .UsContent {
    text-align: left;
    line-height: 25px;
    font-size: 14px;
    color: #606266;
    text-indent:2em
  }
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    margin-right: 150px;
  }
  </style>
  
  
  // WEBPACK FOOTER //
  // src/components/AboutUsDetail.vue


// WEBPACK FOOTER //
// src/components/imgViews.vue